import { useState } from "react";
import { AnimatePresence } from "framer-motion";
import { IntroLoader } from "@/components/portfolio/IntroLoader";
import { Nav } from "@/components/portfolio/Nav";
import { Hero } from "@/components/portfolio/Hero";
import { Showreel } from "@/components/portfolio/Showreel";
import { EditorialMarquee, CertsMarquee } from "@/components/portfolio/Marquees";
import { Timeline } from "@/components/portfolio/Timeline";
import { Stats } from "@/components/portfolio/Stats";
import { Programs } from "@/components/portfolio/Programs";
import { Leadership } from "@/components/portfolio/Leadership";
import { Contact } from "@/components/portfolio/Contact";
import { Footer } from "@/components/portfolio/Footer";

export default function Portfolio() {
  const [intro, setIntro] = useState(true);
  return (
    <main data-testid="portfolio-page" className="bg-ink text-paper">
      <AnimatePresence>
        {intro && <IntroLoader onFinish={() => setIntro(false)} />}
      </AnimatePresence>
      {!intro && (
        <>
          <Nav />
          <Hero />
          <EditorialMarquee />
          <Showreel />
          <Programs />
          <Timeline />
          <Stats />
          <Leadership />
          <CertsMarquee />
          <Contact />
          <Footer />
        </>
      )}
    </main>
  );
}
